// §5.2 Intro carousel — first visit only. "Skip & Get Started" on every slide.
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { INTRO_SLIDES } from '@/api/constants';
import { INTRO_SEEN_KEY } from './Splash';
import './onboarding.css';

const Intro = () => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);

  const finish = () => {
    localStorage.setItem(INTRO_SEEN_KEY, '1');
    navigate('/welcome', { replace: true });
  };

  const slide = INTRO_SLIDES[index];

  return (
    <div className="nova-ob-dark">
      <div className="nova-ob-card-dark">
        <div className="nova-ob-center">
          <div className="nova-ob-logo-circle">N</div>
          <div className="nova-ob-photo" aria-hidden="true">
            🏙️
          </div>
          <div className="nova-ob-slide-headline">{slide.headline}</div>
          <p className="nova-ob-slide-sub">{slide.subheadline}</p>

          <div className="nova-ob-dots" role="tablist" aria-label="Intro slides">
            {INTRO_SLIDES.map((_, i) => (
              <button
                key={i}
                type="button"
                className={`nova-ob-dot ${i === index ? 'active' : ''}`}
                aria-label={`Slide ${i + 1}`}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>

          <button type="button" className="btn btn-light btn-lg w-100 fw-semibold" onClick={finish}>
            Skip &amp; Get Started
          </button>

          {index < INTRO_SLIDES.length - 1 && (
            <button
              type="button"
              className="btn btn-link text-white mt-2"
              onClick={() => setIndex(index + 1)}
            >
              Next
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Intro;
